<template>
<el-card>
        <h1 :style="{fontSize: '1.125rem', margin: '0 0 1rem' }">ค้นหา</h1>
        <el-row type="flex" :gutter="32" :style="{flexWrap: 'wrap'}">
          <el-col :sm="16">
            <el-date-picker
              :value="getCalendar"
              type="daterange"
              startPlaceholder="Start Date"
              endPlaceholder="End Date"
              :class="getCalendarClass"
              :style="{ width: '100%' }"

              @input="calendarInput($event)"
              @change="calendarChange()" />
          </el-col>
          <el-col
            :sm="8"
            :style="{
              marginTop: ['sm'].includes(this.$mq) ? '0.5rem' : undefined
            }">

            <el-select
              :value="this.type"
              clearable
              placeholder="ชนิด"
              :style="{width: '100%' }"
              @change="comboChange($event)">

              <el-option v-for="transtype in types" 
              :label="getTransLabel(transtype.label)" :value="transtype.value" :key="transtype.id" />
            </el-select>
          </el-col>
        </el-row>
      </el-card>
</template>

<script>
import moment from 'moment'
import elementUiStyles from '@/assets/scss/modules/element-ui.module.scss'
import { IncomeExpenseService } from '@/services'

export default {
  data() {
    const query = this.$route.query

    return {
      start: Date.parse(query.start) ? new Date(query.start) : undefined,
      end: Date.parse(query.end) ? new Date(query.end) : undefined,
      type: query.type ? parseInt(query.type) : undefined,
      types: []
    }
  },

  created() {
    this.fetchTypes()
  },
  computed: {
    getCalendar() {
      return [this.start, this.end]
    },
    getCalendarClass() {
      return elementUiStyles.dateRange;
    }
  },
  methods: {
    getTransLabel(val) {
      return  val? val.replace("จำนำ","ขายฝาก"):"";
    },
    async fetchTypes() {
      const {
        data: { status, result }
      } = await IncomeExpenseService.getTypes({ all: true })

      if (status === 'error') return

      this.types = result.map(item => ({
        label: item.name_locale,
        value: item.id
      }))
    },
    calendarInput(value) {
      if (value) {
          const [start, end] = value
          this.start = start
          this.end = end
        } else {
          this.start = undefined
          this.end = undefined
        }
    },
    async calendarChange() {
        await this.$router.replace({
          query: {
            ...this.$route.query,
            start: this.start
              ? moment(this.start).format('Y-MM-DD')
              : undefined,
            end: this.end
              ? moment(this.end).format('Y-MM-DD')
              : undefined,
            page: undefined
          }
        })
        this.submit()
    },
    async comboChange(value) {
        this.type = value

        await this.$router.replace({
          query: {
            ...this.$route.query,
            type: value || undefined,
            page: undefined
          }
        })

        this.submit()
    },
    submit() {
      this.$emit('submit')
    }
  },
/*
  render() {
    return (
      <el-card>
        <h1 style={{ fontSize: '1.125rem', margin: '0 0 1rem' }}>ค้นหา</h1>
        <el-row type="flex" gutter={32} style={{ flexWrap: 'wrap' }}>
          <el-col sm={16}>
            <el-date-picker
              value={[this.start, this.end]}
              type="daterange"
              startPlaceholder="Start Date"
              endPlaceholder="End Date"
              class={elementUiStyles.dateRange}
              style={{ width: '100%' }}
              onInput={value => {
                if (value) {
                  const [start, end] = value
                  this.start = start
                  this.end = end
                } else {
                  this.start = undefined
                  this.end = undefined
                }
              }}
              onChange={async () => {
                await this.$router.replace({
                  query: {
                    ...this.$route.query,
                    start: this.start
                      ? moment(this.start).format('Y-MM-DD')
                      : undefined,
                    end: this.end
                      ? moment(this.end).format('Y-MM-DD')
                      : undefined,
                    page: undefined
                  }
                })

                this.submit()
              }}
            />
          </el-col>
          <el-col
            sm={8}
            style={{
              marginTop: ['sm'].includes(this.$mq) ? '0.5rem' : undefined
            }}
          >
            <el-select
              value={this.type}
              clearable
              placeholder="ชนิด"
              style={{ width: '100%' }}
              onChange={async value => {
                this.type = value

                await this.$router.replace({
                  query: {
                    ...this.$route.query,
                    type: value || undefined,
                    page: undefined
                  }
                })

                this.submit()
              }}
            >
              {this.types.map(type => (
                <el-option label={type.label} value={type.value} />
              ))}
            </el-select>
          </el-col>
        </el-row>
      </el-card>
    )
  }*/
}
</script>
